import { useState, useEffect } from "react";

import { wsAxiosGet } from "src/helpers/wsAxios";
import { API_URLS } from "src/utils/API_URLS";

export interface Currency {
  code: string;
  name: string;
}

const useGetCurrencies = () => {
  const [currencies, setCurrencies] = useState<Currency[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchCurrencies = async () => {
      setIsLoading(true);
      try {
        const data = await wsAxiosGet<{ [key: string]: string }>({
          url: API_URLS.getCurrencies,
        });

        if (data?.content) {
          const formattedCurrencies = Object.entries(data.content).map(
            ([code, name]) => ({
              code,
              name,
            }),
          );
          setCurrencies(formattedCurrencies);
        }
      } catch (error) {
        console.error("Failed to fetch currencies:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCurrencies();
  }, []);

  return { currencies, isLoading };
};

export default useGetCurrencies;
